/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ExamQuestionLibraryItemId202,
  DeleteApiV1ExamQuestionLibraryItemId400,
  DeleteApiV1ExamQuestionLibraryItemId401,
  DeleteApiV1ExamQuestionLibraryItemId404,
  DeleteApiV1ExamQuestionLibraryItemId500,
  DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
  DeleteApiV1ExamQuestionLibraryItemIdPathParams,
} from "../../types/examQuestionLibraryController/DeleteApiV1ExamQuestionLibraryItemId.ts";

export const deleteApiV1ExamQuestionLibraryItemIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ExamQuestionLibraryItemId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ExamQuestionLibraryItemId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ExamQuestionLibraryItemId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ExamQuestionLibraryItemId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ExamQuestionLibraryItemId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemId500>;

export const deleteApiV1ExamQuestionLibraryItemIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ExamQuestionLibraryItemId202Schema,
  ) as unknown as ToZod<DeleteApiV1ExamQuestionLibraryItemIdMutationResponse>;
